import type { AncestorsBreadcrumbProps } from "./ancestors-breadcrumb.type";

import Breadcrumb from "@/modules/breadcrumb";
import { useOrganizationContext } from "@/modules/organization/organization-context";

import { getAncestorsBreadcrumbItems } from "./ancestors-breadcrumb.helper";

const AncestorsBreadcrumb = ({
  ancestors,
  hideIcon,
  ellipsis,
  compact,
  ...dataOptions
}: AncestorsBreadcrumbProps) => {
  const { contextSlug } = useOrganizationContext();

  const items = getAncestorsBreadcrumbItems(
    contextSlug ?? null,
    ancestors,
    dataOptions
  );

  return (
    <Breadcrumb
      items={items}
      hideIcon={hideIcon}
      ellipsis={ellipsis}
      compact={compact}
    />
  );
};

export default AncestorsBreadcrumb;
